// Атрибуты участника, влияющие на подписки на треки (см. shouldSubscribeToParticipant
// в useGroupTrackSubscriptions.ts).
// groupId — единственный атрибут, меняющийся mid-session и влияющий на подписки
//   (move_participant.ts, create_groups.ts — включая удаление ключа, которое
//   LiveKit присылает как groupId: '' через diffAttributes).
// recordingCandidateKey/recordingGroupId — belt-and-braces: сегодня меняются только
//   в момент входа (token.ts), но если завтра появится API смены таргета записи
//   mid-session, ресинк рекордера не должен потеряться.
// handRaised и прочие атрибуты намеренно отсутствуют: их изменения не должны
// дёргать полный resync всех треков (мигание видео у инициатора).
const SUBSCRIPTION_RELEVANT_ATTRIBUTES = new Set([
  'groupId',
  'recordingCandidateKey',
  'recordingGroupId',
])

export const attributesAffectSubscriptions = (
  changedAttributes: Record<string, string> | null | undefined,
): boolean => {
  if (!changedAttributes) return false
  for (const key of Object.keys(changedAttributes)) {
    if (SUBSCRIPTION_RELEVANT_ATTRIBUTES.has(key)) return true
  }
  return false
}
